import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["statesContainer", "template", "emptyMessage"]

    get nextTasksForValue() {
        const raw = this.data.get("nextTasksForValue")
        if (raw) {
            try { return JSON.parse(raw) } catch (e) { /* fall through */ }
        }
        return ["TaskCompletingState"]
    }

    connect() {
        this.relabelRemoveButtons()
        this.toggleEmptyMessage()
    }

    // Focus lands in the new row so keyboard and screen-reader users are
    // taken to it rather than left on the Add button.
    addState(e) {
        e.preventDefault()
        let content = this.templateTarget.innerHTML
        content = content.replace(/NEW_INDEX/g, this.nextIndex())
        this.statesContainerTarget.insertAdjacentHTML("beforeend", content)
        this.relabelRemoveButtons()
        this.toggleEmptyMessage()
        this.focusFirstField(this.stateRows().pop())
    }

    // Monotonic per-controller index: two rows added within the same
    // millisecond must still get distinct nested-attribute keys.
    nextIndex() {
        this.lastIndex = Math.max((this.lastIndex || 0) + 1, new Date().getTime())
        return this.lastIndex
    }

    // The removed row held focus; hand it to a neighbouring row's Remove
    // button, or to the Add button once no rows are left, so focus is never
    // dropped to the page body.
    removeState(e) {
        e.preventDefault()
        const row = e.target.closest("[data-state-row]")
        const rows = this.stateRows()
        const position = rows.indexOf(row)
        const neighbour = rows[position + 1] || rows[position - 1]
        row.remove()
        this.relabelRemoveButtons()
        this.toggleEmptyMessage()
        this.focusAfterRemoval(neighbour)
    }

    // Remove buttons marked data-remove-label are named after their row's
    // status (data-state-name), or its position while the name is blank, so
    // each one is distinguishable to assistive technology.
    relabelRemoveButtons() {
        this.stateRows().forEach((row, i) => {
            const button = row.querySelector("[data-remove-label]")
            if (!button) return

            const nameField = row.querySelector("[data-state-name]")
            const name = nameField ? nameField.value.trim() : ""
            button.setAttribute("aria-label", `Remove status ${name || `in row ${i + 1}`}`)
        })
    }

    // The optional emptyMessage target explains an editor with no rows, and
    // hides while any row exists.
    toggleEmptyMessage() {
        if (!this.hasEmptyMessageTarget) return

        this.emptyMessageTarget.classList.toggle("hidden", this.stateRows().length > 0)
    }

    stateRows() {
        return Array.from(this.statesContainerTarget.querySelectorAll("[data-state-row]"))
    }

    focusFirstField(row) {
        if (!row) return

        const field = row.querySelector("input:not([type='hidden']), select, textarea")
        if (field) field.focus()
    }

    focusAfterRemoval(neighbour) {
        const target = (neighbour && neighbour.querySelector("[data-action*='#removeState']")) ||
            this.element.querySelector("[data-action*='#addState']")
        if (target) target.focus()
    }

    toggleNextTasks(e) {
        const row = e.target.closest("[data-state-row]")
        const nextTasksDiv = row.querySelector("[data-next-tasks]")
        if (this.nextTasksForValue.includes(e.target.value)) {
            nextTasksDiv.classList.remove("hidden")
        } else {
            nextTasksDiv.classList.add("hidden")
            const select = nextTasksDiv.querySelector("select")
            if (select) {
                select.selectedIndex = -1
            }
        }
    }
}
